import { Link } from "react-router-dom";
import { ClipboardList, Phone } from "lucide-react";
import { COMPANY } from "@/data/site";

const MobileCallBar = () => (
  <div
    className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 gap-2 border-t border-slate-200 bg-white/95 p-3 shadow-[0_-4px_20px_rgba(11,27,61,0.15)] backdrop-blur-md md:hidden"
    data-testid="mobile-sticky-bar"
  >
    <a
      href={COMPANY.phoneHref}
      data-testid="mobile-call-button"
      className="flex items-center justify-center gap-2 rounded-full bg-navy py-3 text-sm font-bold text-white"
    >
      <Phone className="h-4 w-4" />
      Call Now
    </a>
    <Link
      to="/contact"
      data-testid="mobile-estimate-button"
      className="flex items-center justify-center gap-2 rounded-full bg-salmon py-3 text-sm font-bold text-white"
    >
      <ClipboardList className="h-4 w-4" />
      Free Estimate
    </Link>
  </div>
);

export default MobileCallBar;
